import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { CTAButton } from "../CTAButton";
import { faqs } from "../../data/sections";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-5 py-16 sm:py-24" data-id="element-137" data-mp="urko47xxef4y">
      <SectionHeading title="Frequently asked questions" data-id="element-138" data-mp="70f2fc5b0smq" />

      <ul className="mx-auto mt-10 max-w-3xl space-y-3" data-id="element-139" data-mp="731hdwuiyaez">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <li key={f.q} className="overflow-hidden rounded-2xl bg-white ring-1 ring-ink/10" data-id="element-140" data-mp="h0fkyvvcn4pv" data-mpi={i}>
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand" data-id="element-141" data-mp="bz9smz5lpjgv">
                <span className="text-[17px] font-bold leading-snug text-ink" data-id="element-142" data-mp="ms0woiu3bkz3">{f.q}</span>
                <PlusIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-143" data-mp="rrncn01azfbl" />
              </button>
              <AnimatePresence initial={false} data-id="element-144" data-mp="3va6wbe5x1cus">
                {isOpen && <motion.div id={`faq-${i}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-145" data-mp="43duq977nbpq">
                    <p className="px-5 pb-5 text-[16px] leading-relaxed text-ink/80" data-id="element-146" data-mp="3cg1o3ech3vdp">{f.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>

      <CTAButton label="Yes! I'm ready to start practicing" className="mt-10" data-id="element-147" data-mp="iq5yj2xc1tr4" />
    </section>;
}